//
// Copyright 2026 DXOS.org
//

import { BaseError } from '@dxos/errors';

export class SemanticIndexError extends BaseError.extend('SemanticIndexError', 'Semantic index error') {}
